export const AccordionIcon = ({
  isOpen,
  error,
}: {
  isOpen: boolean;
  error?: boolean;
}): JSX.Element => {
  return (
    <div className="mr-4">
      <svg
        className={`${
          isOpen
            ? `rotate-180 ${error ? "text-ldir-red-700" : "text-ldir-blue-100"}`
            : "text-ldir-blue-900"
        } transition-transform duration-100`}
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        viewBox="0 0 26 16"
        fill="currentColor"
        stroke="currentColor"
        role="graphics-symbol"
        aria-hidden
      >
        <path
          d="M23.665 4.55859L13.665 13.4746L13 14.0674L12.335 13.4746L2.33496 4.55859L1.49707 3.8125L2.33496 3.06641L3.24609 2.25391L3.91113 1.66016L4.57715 2.25391L13 9.76269L21.4229 2.25391L22.0889 1.66016L22.7539 2.25391L23.665 3.06641L24.5029 3.8125L23.665 4.55859Z"
          strokeWidth="2"
        />
      </svg>
    </div>
  );
};
